export default __webpack_public_path__ + "static/media/leadevents-logo-white.1ce54af9.svg";